import { API_URL } from '..';
import { fetch } from '../fetchWrapper/fetch';
import { IUpdateCategoryVenuesRequest, IUpdateCategoryVenuesResponse } from './types';

export const updateCategoryVenues = async (
  categoryId: string,
  requestBody: IUpdateCategoryVenuesRequest,
): Promise<IUpdateCategoryVenuesResponse> => {
  try {
    const body = JSON.stringify(requestBody);

    const response = await fetch(`${API_URL}/venues/categories/${categoryId}/venues`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    });

    if (!response.ok) {
      throw new Error('Failed to update venues categories: response not ok');
    }

    return await response.json();
  } catch {
    throw new Error('Error updating linked venues categories');
  }
};
